//react...
import React from "react";

//styles...
import "./ProductsPage.styles.css";
//react-bootstrap...
import { Card, Row, Col, Container } from "react-bootstrap";

const ProductsPage = () => {
  return (
    <Container>
      <Row>
        <Col>
          <h2 variant="dark" className="mt-4 ms-5 d-inline-block">
            Asphalt Plant
          </h2>

          <Card className="m-3 product-card">
            <Card.Header>Asphalt Plants </Card.Header>
            <Card.Body>
              <Card.Text>from 80 t/h to 400 t/h</Card.Text>
            </Card.Body>
          </Card>
          <Card className="m-3 product-card">
            <Card.Header>Asphalt Recycling Plants </Card.Header>
            <Card.Body>
              <Card.Text>from 20 t/h to 200 t/h</Card.Text>
            </Card.Body>
          </Card>
          <Card className="m-3 product-card">
            <Card.Header>Mobile Asphalt Plant </Card.Header>
            <Card.Body>
              <Card.Text>from 80 t/h to 140 t/h</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <h2 variant="dark" className="mt-4 ms-5 d-inline-block">
            Paver
          </h2>

          <Card className="m-3 product-card">
            <Card.Header>Rubber Wheeled Asphalt Paver</Card.Header>
            <Card.Body>
              <Card.Text>with 2/5m to 9m paving widths</Card.Text>
            </Card.Body>
          </Card>
          <Card className="m-3 product-card">
            <Card.Header>Crawled Asphalt Paver</Card.Header>
            <Card.Body>
              <Card.Text>with 1m to 16m paving widths</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col>
          <h2 variant="dark" className="mt-4 ms-5 d-inline-block">
            Roller
          </h2>

          <Card className="m-3 product-card">
            <Card.Header>Soil Compactors</Card.Header>
            <Card.Text>from 10 to 26 tons operating weight</Card.Text>
          </Card>
          <Card className="m-3 product-card">
            <Card.Header>Double Drum Rollers</Card.Header>
            <Card.Text>from 1/8 to 10 tons operating weight</Card.Text>
          </Card>
          <Card className="m-3 product-card">
            <Card.Header>Rubber Wheeled Rollers</Card.Header>
            <Card.Text>from 14 to 24 tons operating weight</Card.Text>
          </Card>
        </Col>
        <Col>
          <h2 variant="dark" className="mt-4 ms-5 d-inline-block">
            Road Marking Machinery
          </h2>

          <Card className="m-3 product-card">
            <Card.Header>Hot Marking Machinery</Card.Header>
          </Card>
          <Card className="m-3 product-card">
            <Card.Header>Cold Marking Machinery</Card.Header>
          </Card>
          <Card className="m-3 product-card">
            <Card.Header>Double Components Marking Machinery</Card.Header>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ProductsPage;
